<template>
  <div class="dataOverview">
    <div class="title">数据概览</div>
    <div class="amount-container">
      <div class="top">
        <div class="accountBalance">
          <div class="rubric">企业账户余额 
            <a-tooltip placement="top" title="实际可用余额，企业可使用的余额">
              <!-- <app-icon type="question" class="tipIcon" /> -->
              <i class="icon-question write" />
            </a-tooltip>
          </div>
          <div class="amount">¥<span>{{ splitNumberString(financeDetail?.availableAmount).integer }}.</span>{{ splitNumberString(financeDetail?.availableAmount).decimal }}</div>
          <div class="btn" @click.prevent="onGoFinance">去充值</div>
        </div>
        <div>
          <div class="rubric">总金额
            <a-tooltip placement="top" title="企业账户的总金额，包含可用余额+冻结金额">
              <!-- <app-icon type="question" class="tipIcon" /> -->
              <i class="icon-question" />
            </a-tooltip>
          </div>
          <div class="amount">¥<span>{{ splitNumberString(financeDetail?.totalBalance).integer }}.</span>{{ splitNumberString(financeDetail?.totalBalance).decimal }}</div>
        </div>
        <div>
          <div class="rubric">冻结金额
            <a-tooltip placement="top" title="企业账户中暂不能使用的金额">
              <!-- <app-icon type="question" class="tipIcon" /> -->
              <i class="icon-question" />
            </a-tooltip>
          </div>
          <div class="amount">¥<span>{{ splitNumberString(financeDetail?.enterpriseFrozenAmount).integer }}.</span>{{ splitNumberString(financeDetail?.enterpriseFrozenAmount).decimal }}</div>
        </div>
      </div>
      <div v-if="!hasSubsidiary" class="bottom">
        <div>
          <div class="rubric">已分配额度（未使用）</div>
          <div class="amount">¥<span>{{ splitNumberString(financeDetail?.enterpriseAssignedQuota).integer }}.</span>{{ splitNumberString(financeDetail?.enterpriseAssignedQuota).decimal }}</div>
        </div>
        <div>
          <div class="rubric">可开发票金额
            <a-tooltip placement="top" title="企业当前可开票订单的可开发票总金额">
              <!-- <app-icon type="question" class="tipIcon" /> -->
              <i class="icon-question" />
            </a-tooltip>
          </div>
          <div class="amount">¥<span>{{ splitNumberString(financeDetail?.invoice).integer }}.</span>{{ splitNumberString(financeDetail?.invoice).decimal }}
            <div class="btn" @click.prevent="onGoFapiao">开发票</div>
          </div>
        </div>
      </div>
      <div v-if="hasSubsidiary" class="bottom--has-subsidiaries">
        <ul>
          <li>
            <div class="select-container">
              <span>子公司</span>
              <a-select v-model:value="filterParams.childEnterpriseId" :filter-option="filterOption" @change="(e) => changeEnterprise(e, 'childEnterprise')">
                <template #suffixIcon> <i class="icon-select" /> </template>
                <a-select-option v-for="item in childEnterprise" :key="item.id" :value="item.id">{{ item.enterpriseName }}</a-select-option>
              </a-select>
            </div>
            <div class="subsidiaries-amount-list">
              <div class="subsidiaries-amount-list--item">
                <div class="subsidiaries-amount-list--item-title">子公司账户余额</div>
                <div class="subsidiaries-amount-list--item-amount">¥<span>{{ splitNumberString(financeDetail?.childEnterpriseBalance/100).integer }}.</span>{{ splitNumberString(financeDetail?.childEnterpriseBalance/100).decimal }}</div>
              </div>
              <div class="subsidiaries-amount-list--item">
                <div class="subsidiaries-amount-list--item-title">已分配额度 (未使用)</div>
                <div class="subsidiaries-amount-list--item-amount">¥<span>{{ splitNumberString(financeDetail?.childEnterpriseAssignedQuota).integer }}.</span>{{ splitNumberString(financeDetail?.childEnterpriseAssignedQuota).decimal }}</div>
              </div>
            </div>
          </li>
          <li>
            <div class="select-container">
              <span>公司</span>
              <a-select v-model:value="filterParams.allEnterpriseId" :filter-option="filterOption" @change="(e) => changeEnterprise(e, 'invoice')">
                <template #suffixIcon> <i class="icon-select" /> </template>
                <a-select-option v-for="item in allEnterprise" :key="item.id" :value="item.id">{{ item.enterpriseName }}</a-select-option>
              </a-select>
            </div>
            <div class="subsidiaries-amount-list">
              <div class="subsidiaries-amount-list--item">
                <div class="subsidiaries-amount-list--item-title">可开发票金额
                  <a-tooltip placement="top" title="企业当前可开票订单的可开发票总金额">
                    <!-- <app-icon type="question" class="tipIcon" /> -->
                    <i class="icon-question" />
                  </a-tooltip>
                </div>
                <div class="subsidiaries-amount-list--item-amount">¥<span>{{ splitNumberString(financeDetail?.invoice).integer }}.</span>{{ splitNumberString(financeDetail?.invoice).decimal }} 
                  <div class="btn" @click.prevent="onGoFapiao">开发票</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineComponent, onMounted, computed, ref, watch, reactive } from 'vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import router from '@/router';
import { createApiUrl } from '@/utils/utils';
import { request } from '@/utils/request';
import { splitNumberString } from '@/utils/illuminate';


const store = useStore();
// 跳转
const onGoFinance = () => {
  router.push({ name: 'finance.top_up' });
};
const onGoFapiao = () => {
  router.push({ name: 'fapiao.issue_houpiao.list' });
};
const model = ref('enterprise');
const financeDetail = ref({});
const allEnterprise = ref([]);
const childEnterprise = ref([]);

const filterParams = reactive({
  allEnterpriseId: store.state.User.enterprise.enterpriseId, // 默认选中“全部”；
  childEnterpriseId: '',
});

const filterOption = (input, option) => option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const getEnterprise = async () => {
  let res;
  try {
    res = await request.get(createApiUrl('/newlinkSass/enterprise/find-child-enterprise'), { params: { enterpriseId: store.state.User.enterprise.enterpriseId } });
    allEnterprise.value = res.data;
    const childData = JSON.parse(JSON.stringify(res.data));
    const index = childData.findIndex(item => item.id === store.state.User.enterprise.enterpriseId);
    if (index !== -1) {
      childData.splice(index, 1, { id: '', enterpriseName: '全部' });
    }
    childEnterprise.value = childData;
  } catch (e) {
    return message.error(e.message);
  }

};
// 获取价格信息
const loadFinanceDetail = async (params = {}) => {
  let res;
  try {
    res = await request.get(createApiUrl('/newlinkSass/finance/find-finance-detail'), { params });
    // financeDetail.value = res.data || {};
    switch (model.value) {
      case 'childEnterprise': 
        financeDetail.value.childEnterpriseBalance = res.data.childEnterpriseBalance || 0;
        financeDetail.value.childEnterpriseAssignedQuota = res.data.childEnterpriseAssignedQuota || 0;
        break;
      case 'invoice':
        financeDetail.value.invoice = res.data.invoice || 0;
        break;
      default: 
        // assignWithDefault(financeDetail.value, res.data, defaultFinanceDetail);
        financeDetail.value = res.data || {};
        break;
    }
  } catch (e) {
    return message.error(e.message);
  }
};

const changeEnterprise = async (e, type) => {
  model.value = type;
  if (type === 'childEnterprise') filterParams.childEnterpriseId = e;
  else filterParams.allEnterpriseId = e;
  loadFinanceDetail({ queryEnterpriseId: e });
};
onMounted(() => {
  loadFinanceDetail();
  getEnterprise();
});

watch(() => store.state.User.enterprise, val => {
  if (val && val.enterpriseId) {
    model.value = 'enterprise';
    loadFinanceDetail();
    getEnterprise();
    filterParams.allEnterpriseId = val.enterpriseId;
    filterParams.childEnterpriseId = '';
  }
});
</script>

<style lang="scss" scoped>
.dataOverview {
  flex-shrink: 0;
  border-radius: 16px;
  background: #fff;
  padding: 20px;

  .title {
    color: #1d2129;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 16px;

    span {
      color: #86909c;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }

  .amount-container {
    border-radius: 12px;
    background: linear-gradient(115deg, #f4f8ff 52.6%, #fbf7ff 96.8%);
    padding: 4px 4px 0 0;

    .top,
    .bottom {
      background: #fff;
      border-radius: 8px;
      height: 160px;
      display: flex;
      justify-content: space-between;

      > div {
        width: 33.3%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        padding-left: 30px;

        &:last-child,
        &:nth-child(2) {
          &::before {
            content: "";
            position: absolute;
            top: calc(50% - 32px);
            left: 0;
            width: 1px;
            height: 63px;
            background: rgba(41, 130, 255, 0.1);
          }

          &::after {
            content: "";
            position: absolute;
            top: calc(50% - 19px);
            left: -19px;
            width: 38px;
            height: 38px;
            background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/equalTo.png) center center no-repeat;
            background-size: cover;
          }
        }

        &:last-child::after {
          background-image: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/jianhao.png);
        }

        .rubric {
          color: #86909c;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px; /* 171.429% */
          margin-bottom: 10px;
        }

        .amount {
          color: #1d2129;
          font-size: 20px;
          font-weight: 700;
          line-height: 32px; /* 160% */

          span {
            color: #1d2129;
            font-size: 28px;
            line-height: 32px;
          }
        }

        .btn {
          width: 88px;
          padding: 8px 16px;
          border-radius: 8px;
          background: #fff;
          border: 1px solid #2982ff;
          color: #2982ff;
          text-align: center;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
        }

        &.accountBalance {
          background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/mask-group.png) right bottom no-repeat;
          border-radius: 8px;
          background-color: #2982ff;
          padding: 19px 24px;
          color: #fff;
          background-size: contain;

          .rubric {
            color: #fff;
            margin-bottom: 0;

            .tipIcon {
              color: #fff;
            }
          }

          .amount {
            color: #fff;
            margin-bottom: 20px;

            span {
              color: #fff;
            }
          }
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: flex-start;
      background: none;

      > div {
        width: 33.3%;
        padding-left: 30px;

        &:last-child {
          flex: 1;

          &::after {
            display: none;
          }

          .btn {
            display: inline-block;
            line-height: 20px;
            margin-left: 32px;
            position: relative;
            top: -6px;
            cursor: pointer;
          }
        }
      }
    }

    .bottom--has-subsidiaries {
      ul {
        display: flex;
        justify-content: space-between;
        padding: 20px 19px 32px 12px;

        li {
          padding-right: 32px;
          flex: 1;

          &:last-child {
            padding-left: 20px;
            padding-right: 0;
            border-left: solid 1px rgba(41, 130, 255, 0.1);
          }

          .select-container {
            width: 100%;
            display: flex;
            height: 36px;
            line-height: 36px;
            border-radius: 8px;
            background: #fff;

            span {
              padding: 7px 12px 7px 12px;
              color: #4e5969;
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
              min-width: 52px;
            }

            .icon-select {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url('https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/select-down.png') no-repeat center;
              background-size: cover;
            }
          }

          .subsidiaries-amount-list {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 17px;
            padding-left: 12px;

            &--item {
              flex: 1;

              &-title {
                color: #86909c;
                font-size: 14px;
                font-weight: 400;
                line-height: 24px; /* 171.429% */
                margin-bottom: 10px;
              }

              &-amount {
                color: #1d2129;
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 32px;
                display: flex;
                align-items: baseline;

                span {
                  font-size: 28px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 32px;
                }

                .btn {
                  border-radius: 8px;
                  border: 1px solid #2982ff;
                  background: #fff;
                  color: #2982ff;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 500;
                  margin-left: 32px;
                  margin-top: -6px;
                  width: 88px;
                  line-height: 36px;
                  height: 36px;
                  position: relative;
                  top: -6px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }

  .icon-question {
    width: 14px;
    height: 14px;
    display: inline-block;
    background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/question.png) no-repeat center;
    background-size: cover;
    cursor: pointer;
    position: relative;
    top: 2px;

    &.write {
      background-image: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/question1.png);
    }

    &::before {
      content: "";
    }
  }
}
</style>
